<template>
  <div class="socore">
    {{ score }}
  </div>
</template>

<script>
export default {
    props:['score']

}
</script>

<style lang="scss" scoped>
.socore {
    position: relative;
    width: 120px;
    height: 120px;
    font-size: 30px;
    color: #FD5A38;
    font-weight: bold;
    text-align: center;
    line-height: 120px;
    border: 4px solid #FD5A38;
    border-radius: 50%;
    transform: rotate(-25deg);

    span {
        transform:rotate(180deg);
    }
}
.socore::before {
    position: absolute;
    content: '';
    width: 105px;
    height: 105px;
    left: 50%;
    top: 50%;
   	transform: translate(-50%, -50%);
    border: 2px solid #FD5A38;
    border-radius: 50%;
    // background: #FD5A38;
}
</style>


// WEBPACK FOOTER //
// src/view/Panel/housework/components/student/Score.vue